import SkeletonTable from "@/components/SkeletonTable"
import useSessionStorage from "@/hooks/useSessionStorage"
import { useUser } from "@/hooks/useUser"
import { getDataStep } from "@/services/getData"
import { useQuery } from "@tanstack/react-query"
import { Navigate, Outlet, useSearchParams } from "react-router-dom"

export default function StepPenerimaanPascaMiddleware() {
  const { user } = useUser()
  const [searchParams] = useSearchParams()
  // const sessionPeriode?.id_sys_periode = searchParams.get("periode");
  const stepParams = searchParams.get("step")

  const [sessionPeriode] = useSessionStorage("sessionPeriode", {
    id_sys_periode: "",
  })

  const { data: dataStep, isPending } = useQuery({
    queryKey: ["dataStep", user?.id, sessionPeriode?.id_sys_periode],
    queryFn: () => getDataStep(sessionPeriode?.id_sys_periode || ""),
    enabled: !!user?.id && !!sessionPeriode?.id_sys_periode,
  })

  if (isPending) {
    return <SkeletonTable />
  }

  const queryParams = new URLSearchParams(location.search)

  if (stepParams === "2" && dataStep?.data_diri !== 1) {
    queryParams.set("step", "1")
    return <Navigate to={`${location.pathname}?${queryParams.toString()}`} />
  }

  if (stepParams === "3" && dataStep?.data_pilihan_prodi !== 1) {
    queryParams.set("step", "1")
    return <Navigate to={`${location.pathname}?${queryParams.toString()}`} />
  }

  if (stepParams === "4" && dataStep?.data_berkas !== 1) {
    queryParams.set("step", "1")
    return <Navigate to={`${location.pathname}?${queryParams.toString()}`} />
  }

  return <Outlet />
}
